





















import Vue from "vue";
export default Vue.extend({
  computed: {
    weekLabel() {
      return new Date().toUTCString().split(",")[0].toUpperCase();
    },
    monthLabel() {
      return (
        new Date().toUTCString().split(" ")[2].toUpperCase() +
        " " +
        new Date().getDate()
      );
    },
  },
});
